/*
    The account navigation, as data.

    Same reason the subscribe forms are built from arrays in utils/data.js:
    adding or reordering a settings page should be an edit here, not a new
    block of JSX in two places (the desktop sidebar and the mobile strip are
    one component reading this list).

    `exact` matters only for the index route — without it "/account" stays
    highlighted on every child page.
*/
export const ACCOUNT_NAV_ITEMS = [
  {
    key: "details",
    label: "My Details",
    to: "/account",
    exact: true,
  },
  {
    key: "security",
    label: "Security",
    to: "/account/security",
  },
  {
    key: "billing",
    label: "Billing",
    to: "/account/billing",
  },
  {
    key: "plan",
    label: "Plan",
    to: "/account/plan",
  },
  {
    key: "api",
    label: "API Management",
    to: "/account/api",
    // Renders the API access status pill after the label, on the same line.
    badge: "apiAccess",
  },
];

/*
    Where "Settings" means. The navbar, the user icon and the post-subscribe
    redirect all point at a named constant rather than a literal, so the
    default landing page can move without hunting for strings.
*/
export const ACCOUNT_HOME = "/account";
export const ACCOUNT_API = "/account/api";
export const ACCOUNT_PLAN = "/account/plan";

export default ACCOUNT_NAV_ITEMS;
